import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import type { Permit, PermitFormKit, PermitNew, PermitVersion } from "./permit";
import { LE } from "@/constants/enums";
import { format } from "date-fns/fp/format";
import { TZDate } from "@date-fns/tz";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
  formatPermitDates,
  appendTimeSuffixToDates,
};

function addAuthRequestFields(entity: Permit) {
  entity._authRequestFields = ["id", "statusMurn", "facilityId", "typeMurn"];
  return entity;
}


function formatPermitDates(date: string | undefined) {
  if (!date) return undefined;
  const trimmedDate = date.slice(0, 10); //get just the data ex: 2015-05-14, 12/05/2015
  const utcDate = new TZDate(`${trimmedDate}T00:00:00.000Z`, "UTC"); //convert date to utc time date. FE is going to add it no matter what so if we want it to 'ignore' the time, we need to make the time on the FE match the BE
  const formattedShortDateDisplay = format("P")(utcDate); //format the display. As of current this is the formatter for MUIs shortDate display
  return formattedShortDateDisplay;
}

function appendTimeSuffixToDates(date: string) {
  if (!date) return undefined;
  return (date += "T00:00:00.000Z");
}

/**
 * Copies the current version's number/dates/status up onto the permit so the existing list/view/edit
 * surfaces can bind to them directly (the versioned API keeps them on {@link Permit.currentVersion}).
 */
function flattenCurrentVersion(entity: Permit) {
  const version = entity.currentVersion;
  if (version) {
    entity.statusMurn = version.statusMurn;
  }
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Permit }) {
  addAuthRequestFields(response.data);
  flattenCurrentVersion(response.data);
  await fillLookupValuesByPropertyNames(response.data, ["staffMurn", "typeMurn", "statusMurn"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Permit }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function getInitialData() {
  const result = { versionTypeMurn: LE.PermitVersionType.New } as PermitNew;
  return addAuthRequestFields(result as Permit);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Permit) {
  flattenCurrentVersion(data);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: PermitFormKit) {}
